module.exports = __webpack_public_path__ + "img/update-arrows.6a56ccf9.svg";